import React from 'react';
import { Music, Users, Award, Heart } from 'lucide-react';
import { aboutData } from '../data/mock';

const iconMap = {
  Music: Music,
  Users: Users,
  Award: Award,
  Heart: Heart
};

const About = () => {
  return (
    <section id="sobre" className="py-20 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            {aboutData.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto"></div>
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <div className="order-2 md:order-1">
            <p className="text-lg text-gray-300 leading-relaxed mb-8">
              {aboutData.description}
            </p>
            
            {/* Highlights Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {aboutData.highlights.map((highlight, index) => {
                const IconComponent = iconMap[highlight.icon];
                return (
                  <div 
                    key={index}
                    className="group p-6 bg-gray-800/40 backdrop-blur-sm rounded-xl border border-gray-700/50 hover:border-amber-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/10 hover:-translate-y-1"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                          <IconComponent className="text-black" size={24} />
                        </div>
                      </div>
                      <div>
                        <h3 className="text-white font-semibold mb-2 group-hover:text-amber-400 transition-colors">
                          {highlight.title}
                        </h3>
                        <p className="text-sm text-gray-400">
                          {highlight.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Video */}
          <div className="order-1 md:order-2">
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-amber-600 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-300"></div>
              <video 
                src="/video-presentacion.mov"
                controls
                className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover"
                poster="/logo-masterclass.png"
              >
                Tu navegador no soporta el elemento de video.
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
